import useStoreSearchWithInventory from "./use-stores-search-with-inventory.js";
import useStoreSearchWithoutInventory from "./use-stores-search-without-inventory.js";
const useStoresSearchHook = (sku) => sku ? useStoreSearchWithInventory : useStoreSearchWithoutInventory;
export {
  useStoresSearchHook as default
};
//# sourceMappingURL=use-stores-search-hook.js.map
